import { render, staticRenderFns } from "./FormWizardSize.vue?vue&type=template&id=6ce0d61c"
import script from "./FormWizardSize.vue?vue&type=script&lang=js"
export * from "./FormWizardSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports